import { localize } from '/react4xp/mixins/helpers';

export const columns = (
    translations: Record<string, any>,
    commonTranslations: Record<string, any>
) => [
    {
        title: localize('iin-bin', commonTranslations),
        dataIndex: 'iinBin',
        key: 'iinBin',
    },
    {
        title: localize('false-deals-full-name', translations),
        dataIndex: 'fullName',
        key: 'fullName',
    },
    {
        title: localize('false-deals-act-number', translations),
        dataIndex: 'actNumber',
        key: 'actNumber',
    },
    {
        title: localize('false-deals-date-drawing-up', translations),
        dataIndex: 'preparationDate',
        key: 'preparationDate',
    },
    {
        title: localize('false-deals-date-placement', translations),
        dataIndex: 'createdDate',
        key: 'createdDate',
    },
];
